module.exports = __webpack_public_path__ + "img/and_pump(old)(old).dd8d4261.png";